/* eslint-disable react/prop-types */
import { Pagination } from 'antd';
import { useEffect, useState } from 'react';
import { useEventCallback } from '@icp/hooks';
import { getSearchParam, updateSearchParam } from '@icp/utils';

function PaginationStatusBar(props) {
  const { api, context } = props;

  const [, setRefreshFlag] = useState(Date.now());

  const currentPageKey = context.id ? `${context.id}-page` : null;

  const restoreFromURL = useEventCallback(() => {
    if (!currentPageKey) return;
    const urlCurrentPage = Number(getSearchParam(currentPageKey));
    const tableCurrentPage = api.paginationGetCurrentPage();
    if (!Number.isNaN(urlCurrentPage) && urlCurrentPage !== tableCurrentPage) {
      api.paginationGoToPage(urlCurrentPage);
    }
  });

  const updateURL = useEventCallback(() => {
    if (!currentPageKey) return;
    const tableCurrentPage = api.paginationGetCurrentPage();
    updateSearchParam(currentPageKey, tableCurrentPage);
  });

  const handlePaginationChanged = useEventCallback((event) => {
    const { newData, newPage } = event;

    // 测试下来 newData 只有在 clientSide 的时候才会是 true
    if (newData) {
      restoreFromURL();
    } else if (newPage) {
      updateURL();
    }

    setRefreshFlag(Date.now());
  });

  useEffect(() => {
    // ag-grid 没有参数指定初始的 current page，也无法在 gridReady 的时候立即去调用 api.paginationGoToPage。
    // 测试下来是在 paginationChanged event 里去调用 api.paginationGoToPage 是有效的。
    // 这样的结果是 table 一定会加载第一页的数据。
    api.addEventListener('paginationChanged', handlePaginationChanged);
    // server side 模式在数据第一次成功加载之前调用 api.paginationGoToPage() 不管参数是多少都只会是第 0 页，
    // 所以需要在 firstDataRendered 的时候继续从 url 恢复一下状态
    api.addEventListener('firstDataRendered', restoreFromURL);

    return () => {
      if (!api.isDestroyed()) {
        api.removeEventListener('paginationChanged', handlePaginationChanged);
      }
    };
  }, [api, handlePaginationChanged, restoreFromURL]);

  const handlePageChange = (nextPage) => {
    // ag-grid page start with 0, but antd page start with 1.
    api.paginationGoToPage(nextPage - 1);
  };

  const handleShowSizeChange = (newCurrent, newPageSize) => {
    // 如果改了 cacheBlockSize，ag-grid 一定会跳转到第一页去，后面的 api.paginationGoToPage(newCurrent - 1); 就无效了
    // 所以现在有个问题是 cacheBlockSize 是一次性的不会更新，
    // 例如，刚开始 paginationPageSize = 20，在页面改成 50 过后，cacheBlockSize 还是 20，那一页 table 就会发 3 个请求
    // api.setCacheBlockSize(newPageSize);
    api.setGridOption('paginationPageSize', newPageSize);
    api.paginationGoToPage(newCurrent - 1);
  };

  const current = api.paginationGetCurrentPage();
  const pageSize = api.paginationGetPageSize();
  const total = api.paginationGetRowCount();

  return (
    <Pagination
      current={current + 1}
      className="icp-table-pagination icp-center"
      size="small"
      showQuickJumper={true}
      showSizeChanger={true}
      pageSize={pageSize}
      pageSizeOptions={context.pageSizeOptions}
      total={total}
      onChange={handlePageChange}
      onShowSizeChange={handleShowSizeChange}
    />
  );
}

export default PaginationStatusBar;
